var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpiredImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200.984,
    height: 135.537,
    viewBox: "0 0 200.984 135.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error_image",
    "data-name": "Error image",
    transform: "translate(-79.508 -234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character_00000054949217738369364030000017704033593143831179_",
    transform: "translate(79.508 234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(7.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M194.943,132.5H22.617a6.59,6.59,0,0,1-6.591-6.59V6.59A6.59,6.59,0,0,1,22.617,0H194.943a6.59,6.59,0,0,1,6.59,6.59V125.909A6.59,6.59,0,0,1,194.943,132.5Z",
    transform: "translate(-16.026)",
    fill: "url(#linear-gradient)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 123.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M192.932,285.555H8.052A8.052,8.052,0,0,1,0,277.5v-3.541H200.984V277.5A8.052,8.052,0,0,1,192.932,285.555Z",
    transform: "translate(0 -273.961)",
    fill: "url(#linear-gradient)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(12.23 5.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 175.03,
    height: 111.895,
    fill: "#545252"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(81.717 122.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M180.625,271.214l2.494,4.285h35.095l2.316-4.285Z",
    transform: "translate(-180.625 -271.214)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(15.655 9.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(0.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M201.7,127.758H36.482A1.481,1.481,0,0,1,35,126.278V21.49a1.481,1.481,0,0,1,1.48-1.48H201.7a1.48,1.48,0,0,1,1.48,1.48V126.278A1.48,1.48,0,0,1,201.7,127.758Z",
    transform: "translate(-35.001 -20.01)",
    fill: "url(#linear-gradient-3)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 8.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M202.783,137.661H34.6l.18-99.853h168Z",
    transform: "translate(-34.604 -37.808)",
    fill: "url(#linear-gradient-3)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(11.54 2.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1.385,
    cy: 1.451,
    rx: 1.385,
    ry: 1.451,
    fill: "url(#linear-gradient-3)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(3.146 2.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 1.385,
    cy: 1.451,
    rx: 1.385,
    ry: 1.451,
    fill: "url(#linear-gradient-3)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(7.46 2.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 1.385,
    cy: 1.451,
    rx: 1.385,
    ry: 1.451,
    fill: "url(#linear-gradient-3)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(7.25 122.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M199.939,271.057c0,.072-41.174.13-91.952.13-50.8,0-91.962-.058-91.962-.13s41.165-.129,91.962-.129C158.765,270.928,199.939,270.986,199.939,271.057Z",
    transform: "translate(-16.025 -270.928)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(56.895 23.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M150.723,64.751a35.847,35.847,0,0,1,8.75-3.8l1.8-8.661,14.633-.257,2.105,8.591a35.846,35.846,0,0,1,8.879,3.493l7.4-4.848,10.529,10.166-4.584,7.559a35.843,35.843,0,0,1,3.8,8.752l8.66,1.8.257,14.633-8.591,2.106a35.865,35.865,0,0,1-3.493,8.878l4.847,7.4L195.55,131.088l-7.561-4.584a35.815,35.815,0,0,1-8.751,3.8l-1.8,8.661-14.632.257-2.106-8.592a35.842,35.842,0,0,1-8.878-3.493l-7.4,4.848-10.529-10.166,4.584-7.56a35.848,35.848,0,0,1-3.8-8.751l-8.661-1.8-.257-14.632,8.592-2.107a35.882,35.882,0,0,1,3.493-8.878L133,70.695l10.164-10.529,7.562,4.585Zm7.8,19.493a15.7,15.7,0,1,0,22.2-.39A15.7,15.7,0,0,0,158.524,84.244Z",
    transform: "translate(-125.759 -52.031)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(137.403 28.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M306.624,76.893a12.363,12.363,0,0,1,1.019-3.127l-1.822-2.445,3.279-3.834,2.7,1.421a12.335,12.335,0,0,1,2.931-1.492l.44-3.016,5.029-.393.9,2.911a12.35,12.35,0,0,1,3.127,1.019l2.444-1.822,3.834,3.279-1.421,2.7a12.369,12.369,0,0,1,1.493,2.93l3.016.44.393,5.029-2.911.9a12.341,12.341,0,0,1-1.019,3.127l1.822,2.445L328.6,90.8l-2.7-1.421a12.362,12.362,0,0,1-2.931,1.493l-.44,3.016-5.029.393-.9-2.911a12.338,12.338,0,0,1-3.127-1.019l-2.445,1.822-3.834-3.279,1.421-2.7a12.381,12.381,0,0,1-1.493-2.931l-3.016-.44-.393-5.029,2.912-.9Zm6.816,1.525a5.415,5.415,0,1,0,4.451-4.833A5.416,5.416,0,0,0,313.44,78.418Z",
    transform: "translate(-303.712 -64.007)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(26.902 74.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M62.7,183.005a14.6,14.6,0,0,1,.629-3.83l-2.563-2.526,3.139-5.06,3.4,1.175a14.569,14.569,0,0,1,3.152-2.266l-.027-3.6,5.8-1.358,1.574,3.234a14.58,14.58,0,0,1,3.831.63l2.526-2.563,5.06,3.139-1.175,3.4a14.578,14.578,0,0,1,2.266,3.152l3.6-.026,1.359,5.8-3.235,1.574a14.579,14.579,0,0,1-.63,3.831l2.563,2.527-3.139,5.06-3.4-1.175a14.574,14.574,0,0,1-3.152,2.265l.027,3.6-5.8,1.358-1.574-3.234a14.582,14.582,0,0,1-3.831-.63l-2.526,2.563-5.06-3.139,1.175-3.4a14.592,14.592,0,0,1-2.266-3.152l-3.6.026-1.359-5.8,3.236-1.574Zm8.385,1.632a6.388,6.388,0,1,0,4.762-7.677A6.387,6.387,0,0,0,71.084,184.637Z",
    transform: "translate(-59.463 -165.542)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(38.353 34.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M86.969,85.536a9.291,9.291,0,0,1,.768-2.357l-1.374-1.843,2.472-2.89,2.034,1.071a9.285,9.285,0,0,1,2.21-1.125l.332-2.274,3.792-.3.68,2.195a9.319,9.319,0,0,1,2.358.769l1.843-1.374,2.89,2.472L103.9,81.916a9.332,9.332,0,0,1,1.125,2.209l2.274.332.3,3.792-2.2.68a9.3,9.3,0,0,1-.769,2.358l1.374,1.843-2.472,2.89L101.5,94.949a9.309,9.309,0,0,1-2.21,1.125l-.332,2.274-3.792.3-.68-2.195a9.325,9.325,0,0,1-2.358-.768l-1.843,1.374L87.4,94.583l1.071-2.034a9.335,9.335,0,0,1-1.125-2.21l-2.273-.331-.3-3.792,2.2-.68ZM92.1,87.377a4.08,4.08,0,1,0,3.75-4.385A4.079,4.079,0,0,0,92.1,87.377Z",
    transform: "translate(-84.774 -75.821)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(138.619 76.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M308.286,177.443a8,8,0,0,1,.66-2.025l-1.18-1.583,2.123-2.482,1.747.92a7.985,7.985,0,0,1,1.9-.966l.285-1.953,3.257-.255.585,1.885a7.986,7.986,0,0,1,2.025.66l1.583-1.18,2.483,2.123-.92,1.747a8.019,8.019,0,0,1,.966,1.9l1.953.285.255,3.257-1.885.585a8,8,0,0,1-.661,2.025l1.18,1.583-2.123,2.483-1.747-.92a7.986,7.986,0,0,1-1.9.966l-.285,1.953-3.257.255-.584-1.885a8.017,8.017,0,0,1-2.025-.66l-1.583,1.18-2.482-2.123.92-1.747a8.019,8.019,0,0,1-.966-1.9l-1.953-.285-.255-3.257,1.886-.585Zm4.412,1.582a3.5,3.5,0,1,0,3.221-3.767A3.5,3.5,0,0,0,312.7,179.025Z",
    transform: "translate(-306.4 -169.098)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(70.42 35.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M185.727,132.925H163.218a7.552,7.552,0,0,1-6.54-11.327L167.933,102.1l11.255-19.494a7.551,7.551,0,0,1,13.079,0L203.521,102.1,214.775,121.6a7.551,7.551,0,0,1-6.54,11.327Z",
    transform: "translate(-155.655 -78.836)",
    fill: "#eb4620"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(5.35 4.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M216.432,129.279s.063.116.176.35a3.109,3.109,0,0,1-.3,2.9,3.056,3.056,0,0,1-.848.845,2.782,2.782,0,0,1-1.294.423c-3.836.041-9.374.034-16.224.051l-24.059.025-3.437,0a2.962,2.962,0,0,1-2.773-2.007,3.272,3.272,0,0,1-.114-1.822c.04-.15.088-.3.138-.445.066-.14.128-.285.2-.421l.434-.794,1.757-3.213,7.32-13.381,7.326-13.383,3.485-6.363c.29-.519.555-1.038.862-1.549a3.524,3.524,0,0,1,1.266-1.257,3.723,3.723,0,0,1,3.4-.152,3.546,3.546,0,0,1,1.345,1.074,14.982,14.982,0,0,1,.847,1.451l1.564,2.865q1.542,2.824,2.991,5.478l5.365,9.834,7.754,14.248,2.1,3.879.54,1.012c.121.229.177.349.177.349s-.071-.112-.2-.337l-.561-1-2.136-3.858-7.82-14.212-5.39-9.821-3-5.472-1.569-2.862a15.073,15.073,0,0,0-.831-1.423,3.344,3.344,0,0,0-1.266-1.008,3.508,3.508,0,0,0-3.2.147,3.311,3.311,0,0,0-1.187,1.182c-.3.494-.568,1.026-.856,1.541l-3.48,6.365-7.322,13.386-7.324,13.379-1.759,3.212a6.781,6.781,0,0,0-.749,1.6,3.054,3.054,0,0,0,.1,1.694,2.738,2.738,0,0,0,2.562,1.862l3.437,0,24.059.025,16.219.024a2.7,2.7,0,0,0,1.257-.4,3.008,3.008,0,0,0,.834-.816,3.083,3.083,0,0,0,.537-1.738A3.353,3.353,0,0,0,216.432,129.279Z",
    transform: "translate(-167.48 -88.749)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(26.428 20.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M214.072,144.392a3.858,3.858,0,0,1,7.679,0,3.851,3.851,0,0,1-7.679,0Zm.033-20.435h7.646l-1.286,15.056h-5.108Z",
    transform: "translate(-214.072 -123.957)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(23.655 1.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M215.438,81.651A6.217,6.217,0,0,0,214,81.356a5.068,5.068,0,0,0-3.262,1.091,8.21,8.21,0,0,0-2.157,2.769c-.41.815-.6,1.351-.64,1.338a1.255,1.255,0,0,1,.094-.39,9.646,9.646,0,0,1,.4-1.019,7.642,7.642,0,0,1,2.162-2.883,4.98,4.98,0,0,1,3.419-1.071,3.445,3.445,0,0,1,1.071.262A1.119,1.119,0,0,1,215.438,81.651Z",
    transform: "translate(-207.942 -81.172)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(21.637 7.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 1.172,
    cy: 0.118,
    rx: 1.172,
    ry: 0.118,
    transform: "translate(1.396 0.12) rotate(120.604)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(1.755 12.006)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M199.143,105.373l-35.054,21.6-4.554,7.886,42.083-25.2Z",
    transform: "translate(-159.535 -105.373)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(0.417 21.578)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M203.043,126.532l-46.465,27.409a4.908,4.908,0,0,0,1.01,1.953l46.277-27.939Z",
    transform: "translate(-156.578 -126.532)",
    fill: "#fff"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredImage);
export default __webpack_public_path__ + "static/media/expiredImage.380a53ac26db9d346a9affb368695cde.svg";
export { ForwardRef as ReactComponent };